import { createFileRoute } from '@tanstack/react-router'

import { ReimbursementRulesDocumentationPage } from '../../../../components/pages/backoffice/platform/platform-documentation/reimbursement-rules-documentation-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/documentation/reimbursement-rules')({
  component: () => (
    <PermissionChecker requiredPermissions={['documentation.read']}>
      <ReimbursementRulesDocumentationPage />
    </PermissionChecker>
  ),
})
